import {
  resetPatientMessage,
  getPatients,
  addPatient,
  updatePatient,
} from "store/patients/actions";
import {
  getGroups,
  getMaster,
  getMasterArea,
  getMasterDiaper,
  getMasterStaff,
  unlinkEnrolePatientShared,
  resetMessageEnrole,
} from "store/master/actions";

// import { unlinkEnrolePatientShared } from "store/master/actions";

import { getDevicesByPatient } from "store/devices/actions";
import { useDispatch } from "react-redux";

const PatientApiHook = () => {
  let dispatch = useDispatch();
  const pageInit = () => {
    // dispatch(getPatients());
    dispatch(getGroups());
    dispatch(getMaster());
    dispatch(getMasterArea());
    dispatch(getMasterDiaper());
    dispatch(getMasterStaff());
  };
  const apiGetListDevice = (payload) => {
    dispatch(getDevicesByPatient(payload));
  };
  const apiGetListPatient = (data) => {
    dispatch(getPatients(data));
  };
  const apiAddPatient = (data) => {
    dispatch(addPatient(data));
  };
  const apiUpdatePatient = (data) => {
    dispatch(updatePatient(data));
  };
  const resetMessage = () => {
    dispatch(resetPatientMessage());
  };

  const unlinkPatientShared = (data) => {
    dispatch(unlinkEnrolePatientShared(data));
  }

  const clearMessageEnrole = () => {
    dispatch(resetMessageEnrole());
  };

  return {
    pageInit,
    apiGetListDevice,
    apiGetListPatient,
    apiAddPatient,
    apiUpdatePatient,
    resetMessage,
    unlinkPatientShared,
    clearMessageEnrole
  };
};
export default PatientApiHook;
